import {
  QUALITY_CONTROL_ITEM_KEY,
  QUALITY_CONTROL_ITEM_STATUS,
  QualityControl,
  QualityControlCategory,
  QualityControlCategoryItemWithUuid,
} from '@/api';
import { isEmpty, isNotEmpty } from '@/shared/util';

function hasValidNotes(notes?: null | string): boolean {
  return isNotEmpty(notes);
}

function validateApprovedItem({ itemKey, patientNotes }: QualityControlCategoryItemWithUuid) {
  if (itemKey === QUALITY_CONTROL_ITEM_KEY.ASL) {
    return true;
  }

  return hasValidNotes(patientNotes);
}

function validateRejectedItem({
  internalNotes,
  itemKey,
  patientNotes,
}: QualityControlCategoryItemWithUuid) {
  if (itemKey === QUALITY_CONTROL_ITEM_KEY.ASL) {
    return isNotEmpty(internalNotes);
  }

  return hasValidNotes(internalNotes) && hasValidNotes(patientNotes);
}

function validateUnavailableItem({ patientNotes }: QualityControlCategoryItemWithUuid) {
  return hasValidNotes(patientNotes);
}

export function validateQualityControlCategory(category: QualityControlCategory) {
  const items = category?.items ?? [];

  if (isEmpty(items)) {
    return true;
  }

  const hasValidItems = items.every((item) => {
    switch (item.status) {
      case QUALITY_CONTROL_ITEM_STATUS.PUBLISHED:
      case QUALITY_CONTROL_ITEM_STATUS.APPROVED:
        return validateApprovedItem(item);
      case QUALITY_CONTROL_ITEM_STATUS.REJECTED:
        return validateRejectedItem(item);
      case QUALITY_CONTROL_ITEM_STATUS.UNAVAILABLE:
      case QUALITY_CONTROL_ITEM_STATUS.PROCESSING_FAILED:
      case QUALITY_CONTROL_ITEM_STATUS.INITIAL_CHECK:
        return validateUnavailableItem(item);
      case QUALITY_CONTROL_ITEM_STATUS.PENDING:
        return false;
      default:
        return true;
    }
  });

  return hasValidItems;
}

export function validateQualityControl(data: QualityControl): boolean {
  return data.categories.every(validateQualityControlCategory);
}
